import { motion } from 'framer-motion';
import React from 'react';
import { ReactComponent as ClockIcon } from '../../Icons/clockIcon.svg';
import { ReactComponent as ReadIcon } from '../../Icons/readIcon.svg';
import '../../Styles/Blog/Blog.css';

const FirstBlog = () => {
    return (
        <div className="blog-item-main-container flex-box">
            <motion.div className="blog-item-content-wrapper" initial={{ y: `-1200%`, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5, delay: 0.5 }}>
                <h4 className="blog-item-title">
                    <span onClick={() => window.open(`https://asguru.hashnode.dev/first-phase-experience-towards-transformation`)} className="pointer">First phase experience, Towards Transformation</span>
                </h4>
                <p className="blog-item-brief-view flex-box">
                    <span className="flex-box pointer" onClick={() => window.open(`https://asguru.hashnode.dev/first-phase-experience-towards-transformation`)}>
                        <span className="flex-box blog-item-publish-date">Feb 9, 2021</span>
                        <span className="flex-box blog-item-minutes-of-read">
                            <ClockIcon />
                            7 min read
                        </span>
                        <span className="flex-box blog-item-number-of-views">
                            <ReadIcon />
                            60 views
                        </span>
                    </span>
                </p>
                <p onClick={() => window.open(`https://asguru.hashnode.dev/first-phase-experience-towards-transformation`)} className="pointer">
                    In this blog I have shared my first month experience at Masai, how was my start towards tech, what ups and downs I had to face,
                    how Masai and their IA's helped me out with all my problems. I have even shared how I felt when I had worked in team and built
                    wonderful clone of Mailtrap.io, Happy reading 😀.
                </p>
            </motion.div>
            <motion.div
                className="blog-item-image-wrapper flex-box pointer"
                onClick={() => window.open(`https://asguru.hashnode.dev/first-phase-experience-towards-transformation`)}
                initial={{ y: `-1200%`, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
            >
                <img className="blog-item-image-box" src={process.env.PUBLIC_URL + '/Images/firstBlogCover.png'} alt="first blog" />
            </motion.div>
        </div>
    )
}

export default FirstBlog
